// extracted by mini-css-extract-plugin
module.exports = {"item":"project_item__54m6O","current":"project_current__p6dLJ","pro-img":"project_pro-img__Kq4l2","glowing":"project_glowing__u0V0G"};